import EthereumService from '@/services/ethereum'

export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.kulapApi = options.kulapApi
  }

  async sendForgotPasswordEmail (email, recaptchaToken) {
    const data = { email, recaptchaToken }
    const { data: result } = await this.kulapApi.sendForgotPasswordEmail(data)
    return result
  }
}



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword/service.js